const UidispatcherApiModule = await import("uidispatcher_api/UidispatcherApiModule");
export const GdprStorage = UidispatcherApiModule.GdprStorage;
